import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FeatureConfigService, Product, ProductScope } from '@spartacus/core';
import { CmsComponentData, CurrentProductService, ProductDetailOutlets } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'product-name',
  templateUrl: './product-name.component.html',
  styleUrl: './product-name.component.scss',
  standalone: false,
})
export class ProductNameComponent implements OnInit, OnDestroy {
  private featureConfig = inject(FeatureConfigService);
  outlets = ProductDetailOutlets;
  product$: Observable<Product | null> = this.getProduct();
  subscription = new Subscription();
  tag = '';

  protected getProduct(): Observable<Product | null> {
    const productScopes = [ProductScope.DETAILS, ProductScope.PRICE];
    if (this.featureConfig.isEnabled('showPromotionsInPDP')) {
      productScopes.push(ProductScope.PROMOTIONS);
    }
    return this.currentProductService.getProduct(productScopes);
  }

  constructor(
    protected currentProductService: CurrentProductService,
    private componentData: CmsComponentData<any>,
  ) {}

  ngOnInit(): void {
    this.createTag();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  createTag() {
    this.subscription.add(
      this.componentData.data$.subscribe(data => {
        if (data.styleClasses === 'productName_01') {
          this.tag = '<h1 class="product-name"> teste </h1>';
        } else {
          this.tag = '<p class="h1 product-name"> teste </p>';
        }
      }),
    );
  }
}
